export default __webpack_public_path__ + "static/media/heartViolet.23282e22.svg";